import { TZDate } from '@date-fns/tz';
import { useRef } from 'react';

import { formatDate } from '@dynatrace-sdk/units';

import { calendarFieldCSS } from './Calendar.sty.js';
import { CalendarItem } from './CalendarItem.js';
import { useYear } from './hooks/useYear.js';
import { useFormFieldContext } from '../forms-core/hooks/useFormFieldContext.js';

export const Year = ({ date }: { date: TZDate }) => {
  // Reference of the year button, needed to pass to the hook for proper focus management
  const itemRef = useRef<HTMLDivElement>(null);

  const { ariaLabel, tabIndex, isCurrent, isSelected, onClick, isDisabled } =
    useYear({
      date,
      itemRef,
    });
  const { disabled, ariaDisabled } = useFormFieldContext();
  const highlightColor = isSelected ? 'primary' : 'neutral';

  return (
    <td
      role="presentation"
      className={calendarFieldCSS({
        color: highlightColor,
        isDisabled: isDisabled || disabled || ariaDisabled,
      })}
    >
      <CalendarItem
        ref={itemRef}
        className="calendar-button calendar-body-button"
        isCurrent={isCurrent}
        isSelected={isSelected}
        isDisabled={isDisabled || disabled}
        highlightColor={highlightColor}
        tabIndex={tabIndex}
        role="gridcell"
        aria-selected={!!isSelected}
        ariaLabel={ariaLabel}
        onClick={onClick}
        view="year"
      >
        {formatDate(date, { year: 'numeric' })}
      </CalendarItem>
    </td>
  );
};
Year['displayName'] = 'Year';
